import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, map } from 'rxjs';
import { marked } from 'marked';
import { applyLegalPlaceholders } from '@noisy/legal';
import { legalPlaceholders } from '../config/legal-config';

@Injectable({ providedIn: 'root' })
export class LegalContentService {
  private http = inject(HttpClient);
  private sanitizer = inject(DomSanitizer);

  loadMarkdown(path: string): Observable<SafeHtml> {
    return this.http.get(path, { responseType: 'text' }).pipe(
      map((content) => this.renderMarkdown(content)),
    );
  }

  private renderMarkdown(content: string): SafeHtml {
    const replaced = applyLegalPlaceholders(content, legalPlaceholders);
    const html = marked.parse(replaced, { breaks: true }) as string;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
